module.exports = __webpack_public_path__ + "img/title-bg.86a20a20.png";